import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledLanguageFilter = styled('div')(
  () => css`
    .language-filter {
      .MuiFormControlLabel-root {
        display: flex;
      }
    }
  `
);
